import { createFileRoute } from '@tanstack/react-router';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

import { LogoutButton } from '@/features/auth/components/logout-button';

export const Route = createFileRoute('/_app/dashboard')({
  component: Dashboard,
});

// Placeholder : le vrai tableau de bord arrive avec sa feature — cette page
// matérialise la zone protégée. Le chrome (sidebar, top bar) vient du shell
// via `_app` ; l'écran ne rend que son contenu (pas de <main> propre).
function Dashboard() {
  // Le jour se lit à l'ouverture, pas au montage du module : un onglet laissé
  // ouvert la nuit afficherait la veille.
  const aujourdhui = format(new Date(), 'EEEE d MMMM', { locale: fr });

  return (
    <div className="flex flex-col gap-8 p-8">
      {/* UI-20 : le triptyque titre / sous-titre / action, comme les autres
          écrans. Le H1 portait `text-title`, une classe qui n'existe pas au
          thème : aucune taille ne s'appliquait, il héritait des 16 px de la
          racine. D'où le « H1 à 16 px » relevé par l'audit — pas une variante,
          une classe fantôme. */}
      <header className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-h1 text-foreground">
            Tableau de bord
          </h1>
          <p className="mt-1 text-sm text-n-700 first-letter:uppercase">
            Aujourd’hui — {aujourdhui}
          </p>
        </div>
        <LogoutButton />
      </header>
      <p className="text-body text-n-700">Bienvenue sur Arti Pilotage.</p>
    </div>
  );
}
